import { Link } from "react-router-dom";

export default function NotFound() {
    return (<div>
        <h3>Error: page not found.</h3>
        <Link to="/">Home</Link>
    </div>)
}